import * as i0 from '@angular/core';
import { Pipe, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

class TextHighlightPipe {
    transform(text, searchString) {
        if (text !== undefined && searchString) {
            // TO-DO: MIGHT NEED THIS: searchString.replace(/([ #;?%&,.\-_`+*~\':"!^$[\]()=>|\/@])/g, '\\$1');
            const regexSearchString = searchString.replace(/([ #;?%&,.\-_`+*~:"!^$[\]()=>|@])/g, "\\$1");
            text = text.replace(new RegExp(`(${regexSearchString})`, "gi"), '<span class="highlighted">$1</span>');
        }
        return text;
    }
}
TextHighlightPipe.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: TextHighlightPipe, deps: [], target: i0.ɵɵFactoryTarget.Pipe });
TextHighlightPipe.ɵpipe = i0.ɵɵngDeclarePipe({ minVersion: "14.0.0", version: "15.2.10", ngImport: i0, type: TextHighlightPipe, name: "textHighlight" });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: TextHighlightPipe, decorators: [{
            type: Pipe,
            args: [{
                    name: "textHighlight"
                }]
        }] });

class EllipsisPipe {
    transform(text, length) {
        let spanToBind = "";
        if (text !== undefined) {
            if (text.length > length) {
                text = text.trim();
                spanToBind = `${text.substr(0, length)}...`;
            }
            else {
                text = text.trim();
                spanToBind = `${text} `;
            }
        }
        return spanToBind;
    }
}
EllipsisPipe.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: EllipsisPipe, deps: [], target: i0.ɵɵFactoryTarget.Pipe });
EllipsisPipe.ɵpipe = i0.ɵɵngDeclarePipe({ minVersion: "14.0.0", version: "15.2.10", ngImport: i0, type: EllipsisPipe, name: "textEllipsis" });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: EllipsisPipe, decorators: [{
            type: Pipe,
            args: [{
                    name: "textEllipsis"
                }]
        }] });

class VaCommonModule {
}
VaCommonModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: VaCommonModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
VaCommonModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "15.2.10", ngImport: i0, type: VaCommonModule, declarations: [TextHighlightPipe, EllipsisPipe], imports: [CommonModule], exports: [TextHighlightPipe, EllipsisPipe] });
VaCommonModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: VaCommonModule, imports: [CommonModule] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: VaCommonModule, decorators: [{
            type: NgModule,
            args: [{
                    declarations: [TextHighlightPipe, EllipsisPipe],
                    imports: [
                        CommonModule
                    ],
                    exports: [TextHighlightPipe, EllipsisPipe]
                }]
        }] });

/**
 *
 * @param value Accepts a string input
 * @description The encodeURIComponent does not encode !'()* characters.
 * Use this in places like tab(pg) values.
 * Ex: NewIFRS(3) is a tab of BAML for 005930_KR
 */
function fixedEncodeURIComponent(value) {
    return encodeURIComponent(value).replace(/[!'()*]/g, function (c) {
        return `%${c.charCodeAt(0).toString(16)}`;
    });
}
function deepClone(obj, hash = new WeakMap()) {
    let result;
    // Do not try to clone primitives or functions
    if (Object(obj) !== obj || obj instanceof Function)
        return obj;
    if (hash.has(obj))
        return hash.get(obj); // Cyclic reference
    try { // Try to run constructor (without arguments, as we don't know them)
        result = new obj.constructor();
    }
    catch (e) { // Constructor failed, create object without running the constructor
        result = Object.create(Object.getPrototypeOf(obj));
    }
    // Optional: support for some standard constructors (extend as desired)
    if (obj instanceof Map)
        Array.from(obj, ([key, val]) => result.set(deepClone(key, hash), deepClone(val, hash)));
    else if (obj instanceof Set)
        Array.from(obj, (key) => result.add(deepClone(key, hash)));
    // Register in hash    
    hash.set(obj, result);
    // Clone and assign enumerable own properties recursively
    return Object.assign(result, ...Object.keys(obj).map(key => ({ [key]: deepClone(obj[key], hash) })));
}
;
/**
 * format value based on given precision
 * @param value {number}
 * @param precision {number} decimal precision, default value is 2
 * @returns formatted value
 */
// 
function formatValue(value, precision) {
    const dpPrecision = isNaN(precision) ? 2 : precision;
    return value < 0
        ? addThousandsSeparator(-value, dpPrecision)
        : addThousandsSeparator(value, dpPrecision);
}
function addThousandsSeparator(value, decimals) {
    let val = "";
    //for (15066.084470789277,1) => 15,066.1
    // if (!Number.isInteger(value)) return value.toLocaleString("en-US", { maximumFractionDigits: decimals });
    // //for (67000) => 67,000.00
    // if (Number.isInteger(value)) return value.toLocaleString("en-US", { minimumFractionDigits: decimals });
    val = !Number.isInteger(value)
        ? value.toLocaleString("en-US", { maximumFractionDigits: decimals })
        : value.toLocaleString("en-US", { minimumFractionDigits: decimals });
    /*
      Adding this to put in the number of decimals mentioned in the precision, to only a whole number after rounding it off.
      Ex: value = 39.99448302578609916744757663 and decimals = 1
      Original O/P: 40
      New O/P: 40.0
      */
    if (decimals !== 0 && !val.includes(".")) {
        val = `${val}.${Array(decimals + 1).join("0")}`;
    }
    if (decimals !== 0 &&
        val.includes(".") &&
        val.split(".")[1].length !== decimals) {
        val = `${val}0`;
    }
    return val;
}

/**
 * Generated bundle index. Do not edit.
 */

export { EllipsisPipe, TextHighlightPipe, VaCommonModule, addThousandsSeparator, deepClone, fixedEncodeURIComponent, formatValue };
